import React from "react";
import { Button } from "@/components/ui/button";
import { CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { DialogTrigger } from "@/components/ui/dialog";
import { Plus, Package } from "lucide-react";
interface ParcelTypesHeaderProps {
  onAddClick: () => void;
}
const ParcelTypesHeader = ({
  onAddClick
}: ParcelTypesHeaderProps) => {
  return <CardHeader>
      <div className="flex items-center justify-end">
        
        <Button onClick={onAddClick}>
          <Plus className="h-4 w-4 mr-2" />
          Add Parcel Type
        </Button>
      </div>
    </CardHeader>;
};
export default ParcelTypesHeader;